import {
  STOCK_TAKING_CAR_MANAGEMENT_EXCHANGE_RATES_DATA_MASTER_BEGIN,
  } from '../constants';
  
  export function getExchangeRatesDataMaster() {
    return (dispatch) => {
      dispatch({
        type: STOCK_TAKING_CAR_MANAGEMENT_EXCHANGE_RATES_DATA_MASTER_BEGIN,
        })
    }
  }